import { render } from "./workforce-plan-form.vue?vue&type=template&id=51e057f6&scoped=true"
import script from "./workforce-plan-form.vue?vue&type=script&lang=js"
export * from "./workforce-plan-form.vue?vue&type=script&lang=js"

import "./workforce-plan-form.vue?vue&type=style&index=0&id=51e057f6&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51e057f6"]])

export default __exports__